import { render, staticRenderFns } from "./theme-choice.vue?vue&type=template&id=8fc93f94&scoped=true"
import script from "./theme-choice.vue?vue&type=script&lang=js"
export * from "./theme-choice.vue?vue&type=script&lang=js"
import style0 from "./theme-choice.vue?vue&type=style&index=0&id=8fc93f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc93f94",
  null
  
)

export default component.exports